var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 275,
    viewBox: "0 0 157 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3 0C35.7 0 0 35.7 0 81.3H15.9C15.9 43.5 43.5 16.2 78.3 16.2C113.1 16.2 140.7 43.5 140.7 78.3C140.7 96.6 133.2 113.1 119.4 125.4C108.3 135.3 93.6 140.7 78.3 140.7H70.2V229.5H86.4V156.3C100.5 155.4 117.3 148.5 130.2 136.8C146.7 122.4 156.6 100.5 156.6 78.3C156.6 35.7 120.9 0 78.3 0ZM78.3 249C71.7 249 65.7 255.3 65.7 261.9C65.7 268.2 71.7 274.5 78.3 274.5C84.9 274.5 90.9 268.2 90.9 261.9C90.9 255.3 84.9 249 78.3 249Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolQuestion);
export default __webpack_public_path__ + "static/media/SYMBOL_QUESTION.37893107376ea12288cd0e9515463899.svg";
export { ForwardRef as ReactComponent };